import cls from 'classnames';

import createArray from '../../../utils/createArray';

import { TextColumn } from './types';
import useStyles from './useTextColumnStyles';

const createColumn = ({
  len,
  start,
  items,
  classes,
}: {
  len: number;
  start: number;
  items: TextColumn[];
  classes: ReturnType<typeof useStyles>;
}) => {
  return (
    <div>
      {createArray(len, start).map((i) => {
        const { title, titleHref, description } = items[i];

        const fullTitle = titleHref ? (
          <a className={classes.titleLink} href={titleHref}>
            {title}
          </a>
        ) : (
          title
        );

        return (
          <div key={`left-${i}`} className={classes.itemContainer}>
            <h3 className={cls('fs-16', classes.textTitle)}>{fullTitle}</h3>
            <div className={cls('fs-16', classes.textDescription)}>{description}</div>
          </div>
        );
      })}
    </div>
  );
};

export default function TextColumns({ items }: { items: TextColumn[] }) {
  const classes = useStyles();
  const half = items.length / 2;
  const left = createColumn({ len: half, start: 0, items, classes });
  const right = createColumn({ len: half, start: half, items, classes });

  return (
    <div className={classes.root}>
      <div className={classes.textContainer}>
        {left}
        {right}
      </div>
    </div>
  );
}
